
import React, { useState } from 'react';
import NavBar from '@/components/NavBar';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import MySubmissionsHeader from '@/components/my-submissions/MySubmissionsHeader';
import EmptySubmissions from '@/components/my-submissions/EmptySubmissions';
import SubmissionsList from '@/components/my-submissions/SubmissionsList';
import Footer from '@/components/Footer';
import { useMySubmissions } from '@/hooks/useMySubmissions';

const MySubmissionsPage = () => {
  const [statusFilter, setStatusFilter] = useState<'all' | 'pending' | 'approved' | 'rejected'>('all');
  const { submissions, loading, getStatusCount } = useMySubmissions(statusFilter);

  const filteredSubmissions = submissions.filter(submission => 
    statusFilter === 'all' || submission.status === statusFilter
  );

  return (
    <div className="flex flex-col min-h-screen bg-warm-cream">
      <NavBar />
      
      <main className="flex-1 container px-3 sm:px-4 md:px-6 py-4 sm:py-6 md:py-8">
        <div className="max-w-4xl mx-auto space-y-4 sm:space-y-6">
          <MySubmissionsHeader />

          <Tabs value={statusFilter} onValueChange={(value) => setStatusFilter(value as any)}>
            <TabsList className="grid w-full grid-cols-2 sm:grid-cols-4 h-auto">
              <TabsTrigger value="all" className="text-xs sm:text-sm py-2 sm:py-2.5">
                All ({submissions.length})
              </TabsTrigger>
              <TabsTrigger value="pending" className="text-xs sm:text-sm py-2 sm:py-2.5">
                Pending ({getStatusCount('pending')})
              </TabsTrigger>
              <TabsTrigger value="approved" className="text-xs sm:text-sm py-2 sm:py-2.5">
                Approved ({getStatusCount('approved')})
              </TabsTrigger>
              <TabsTrigger value="rejected" className="text-xs sm:text-sm py-2 sm:py-2.5">
                Rejected ({getStatusCount('rejected')})
              </TabsTrigger>
            </TabsList>

            <TabsContent value={statusFilter} className="mt-4 sm:mt-6">
              {loading ? (
                <div className="text-center py-6 sm:py-8">
                  <div className="animate-pulse text-base sm:text-lg">Loading your submissions...</div>
                </div>
              ) : filteredSubmissions.length === 0 ? (
                <EmptySubmissions statusFilter={statusFilter} />
              ) : (
                <SubmissionsList submissions={filteredSubmissions} />
              )}
            </TabsContent>
          </Tabs>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default MySubmissionsPage;
